import RWD002 from "../class/rwd002";
import customDrawerNav from "./drawerNav";
import customFormConfirm from "./formConfirm";
// import FirstViewEndObserver from "./FirstViewEndObserver";
import customSubNav from "./subNav";
import LazyDisp from "../class/lazydisp";

const [ d, mq ] = [document, window.matchMedia( "(max-width: 899px)" ) ];

export default class CUSTOMIZE extends RWD002 {

  constructor(opt) {
    opt = Object.assign({
      // fixNavを指定すると、スクロール時に固定するクラスを付与する
      fixNav : '[data-role="fixNav"]',
    },opt);

    // 上位クラスのコンストラクタ呼び出し
    super(opt);

    // カスタム用drawerNavのインスタンス化
    this.drawerNav = new customDrawerNav(this.opt.drawerNav);

    // カスタム用サブナビ登録クラスのインスタンス化
    this.Subnav = new customSubNav(this.opt);

    // コメントフォーム用確認画面モーダルのインスタンス化
    this.formConfirm = new customFormConfirm(this.opt.formConfirm);

    this.customInit();
  }

  customInit() {

    // イベント一覧
    d.addEventListener('rwd002.beforeInit', () => false );
    d.addEventListener('rwd002.beforeDomready', () => false );
    d.addEventListener('rwd002.beforeWindowload', () => false );
    d.addEventListener('rwd002.zip2addr', () => false );
    d.addEventListener('drawerNav.beforeInit', () => false );
    d.addEventListener('collapseNav.beforeInit', () => false );
    d.addEventListener('Scroll.beforeInit', () => false );
    d.addEventListener('Scroll.scrollUp', () => false );
    d.addEventListener('Scroll.scrollDown', () => false );
    d.addEventListener('Lazydisp.beforeInit', () => false );

    // テンプレートインスタンスのプロミス
    this.promises.init.then( () => false );
    this.promises.domReady.then( () => false );
    this.promises.windowLoad.then( () => false );

    // テンプレートインスタンスの全非同期メソッドの完了時に実行
    this.promiseAll().then( () => false );

    // サブナビ登録サンプル
    d.addEventListener('rwd002.beforeDomready', () => {
      this.customSubnav();
      if( !mq.matches ) {
        const fixNav = d.querySelector('.fixed_nav');
        // new FirstViewEndObserver(fixNav);
      }
    });

    $(() => {
      // htmlデータ読み込み
      $('[data-load-html]').loadHtml();

      // カレントメニュー
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

      // Promise.all([window.load['loadHtml']]).then(() => this.hashscroll());
      Promise.all([window.load['loadHtml']]).then( () => new LazyDisp('[data-lazydisp]'));
    });
  }

  // サブメニュー追加サンプル(beforeDomreadyに登録して使用)
  customSubnav () {
    /**
     * サブナビ追加メソッド(グローバルナビとフッター)
     * ヘッダー・フッター内の[data-key]属性値をもつ要素すべてに対して、サブナビを追加する
     * 第一引数にセレクタを指定(rwd002.opt.gnav / rwd002.opt.fnav )
     * 第一引数にコンテンツ番号を指定(li[data-key])
     * アイテムの出力HTMLは"subnavItemTemplate"によって出力される
     * 第二引数の個別アイテムにHTMLを指定すると、デフォルトのHTMLを上書きする
     * 親要素liに[data-collapse="true"]を指定すると、サブナビを開閉するボタンを追加する
     */

    // header gnav用サブナビ追加
    this.Subnav.add(this.opt.gnav, 'content1', [
      // 標準出力
      // { label: 'ごみ屋敷の片付け', href: '/service/?mode=detail&article=2'},
      { label: '粗大ゴミ・不用品回収', href: '/service/?mode=detail&article=8'},
      { label: '遺品整理', href: '/service/?mode=detail&article=3'},
      { label: 'エンディングノート', href: '/service/?mode=detail&article=4'},
      { label: '家庭ゴミ定期回収', href: '/service/?mode=detail&article=5'},
      { label: '消火器回収', href: '/service/?mode=detail&article=6'},
      { label: '回収品目別料金表', href: '/service/?mode=detail&article=7'},
    ]);
    this.Subnav.add(this.opt.gnav, 'content5', [
      // 標準出力
      { label: '会社案内', href: '/corp/'},
      { label: '三共の取り組み', href: '/corp/?mode=detail&article=2'},
    ]);

    // footer nav用サブナビ追加
    this.Subnav.add(this.opt.fnav, 'content1', [
      { label: 'サブメニュー01', href: '#'},
      { label: 'サブメニュー02', href: '#'},
      { label: 'サブメニュー03', href: '#'},
    ]);
  }

  loading() {
    d.documentElement.classList.add( this.opt.loadingClass );
    d.documentElement.classList.add( 'is-pageload-available' );
    d.addEventListener('DOMContentLoaded', () => {
      d.documentElement.classList.remove( this.opt.loadingClass );
      d.documentElement.style.opacity = '';
    });
  }

}


$(window).on('load', function () {
  let winH = $(window).height();
  $(window).on('scroll', function () {
    let t = $(this).scrollTop();
    let footPt = $('footer').offset().top;
    let scrollPt = t + winH;
    if (t > 300) {
      $('.fixed_nav').addClass('active');
    } else {
      $('.fixed_nav').removeClass('active');
    }
    if (scrollPt > footPt){
      $('.fixed_nav').addClass('out');
    } else {
      $('.fixed_nav').removeClass('out');
    }
  });
});

$('a[href^="#"]').on('click', function(e) {
	let href = $(this).attr("href");
	let target = $(href == "#" || href == "" ? 'html' : href);
	let position = target.offset().top;

	$.when(
		$("html, body").animate({
			scrollTop: position
		}, 400, "swing"),
		e.preventDefault(),
  ).done(function() {
    setTimeout(function(){
      let diff = target.offset().top;
      if (diff === position) {
      } else {
        $("html, body").animate({
          scrollTop: diff
        }, 5, "swing");
      }
    },600);
	});
  return false;
});

$('.slideTrigger').on('click', function(){
  $(this).toggleClass('open');
  $(this).next('.sub_list').slideToggle();
});

//googlefont 読み込み
window.WebFontConfig = {
  google: {
    families: ['Mulish:500,600,700,800', 'Jost:500,600,700', 'Noto+Serif+JP:500', 'Noto+Sans+JP:400,500,700&subset=japanese']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();